import { create } from 'zustand';

import { FilterValue } from '../types';

type PageAssetFilterStore = FilterValue & {
  setSearch: (value: string) => void;
  setCategory: (category: FilterValue['category']) => void;
  setCountry: (country: FilterValue['country']) => void;
  setCurrency: (currency: FilterValue['currency']) => void;
  setValueFrom: (value: FilterValue['valueFrom']) => void;
  setValueTo: (value: FilterValue['valueTo']) => void;
  setMany: (value: FilterValue) => void;
  reset: () => void;
  resetOneOf: (key: keyof FilterValue) => void;
};

const getInitialState = (): FilterValue => ({
  search: '',
  category: null,
  country: null,
  currency: null,
  valueFrom: null,
  valueTo: null,
});

export const usePageAssetsFilterStore = create<PageAssetFilterStore>((set) => ({
  ...getInitialState(),
  setSearch: (search) => set({ search }),
  setCategory: (category) => set({ category }),
  setCountry: (country) => set({ country }),
  setCurrency: (currency) => set({ currency }),
  setValueFrom: (valueFrom) => set({ valueFrom }),
  setValueTo: (valueTo) => set({ valueTo }),
  setMany: (filters) => set(filters),
  reset: () => set(getInitialState()),
  resetOneOf: (key: keyof FilterValue) => set({ [key]: getInitialState()[key] }),
}));
